import RegisterPage from "app/components/_pages/auth/Register/RegisterPage";

export const registerPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  routes: [
    {
      path: "/register",
      component: RegisterPage
    }
  ]
};
